import Swiper from 'swiper';

// import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';

let introSliderLength = jQuery('.page-intro__slider .swiper-slide').length;

if (introSliderLength > 1) {
    const mySwiper = new Swiper('.page-intro__slider', {
        effect: 'fade',
        speed: 1000,
        navigation: {
            nextEl: '.page-intro__navigation--next',
            prevEl: '.page-intro__navigation--prev',
        },
        fadeEffect: {
            crossFade: true
        },
    });
}